//Vendor
import Paragraph from 'Scripts/animations/Paragraph'
import Page from 'Scripts/classes/Page'
import Particles from 'Scripts/webgl/Particles'


//Class
export default class About extends Page {
  constructor() {
    super(
      'about',
      {
        container: '.about__wrapper',
        elements: {
          title: '.about__title',
          descriptif: '.about',
        }
      })

    //Methods
    this.init()

  }

  init() {    
    this.particles = new Particles({canvas : '.particles'})
  }


  /**
  * Animations.
  */
  show() {
    this.text = new Paragraph({element : this.elements.descriptif})  
    return super.show()  
  }

  hide() {
    return super.hide()
  }

}


